module.exports = __webpack_public_path__ + "img/empty.79ba9152.png";